export default __webpack_public_path__ + "static/media/311.5d5d26a6.png";